import { compose } from 'lodash/fp'
import React from 'react'
import { FiEye, FiEyeOff } from 'react-icons/fi'
import Flex from 'typescript-styled-flex'
import { theme } from '../../../theme'
import { Input } from '../elements'
import FormElement from '../FormElement'
import { IFormElementProps } from '../FormElement/FormInput'
import withReduxForm from '../withReduxForm'
import IconWrapper from './IconWrapper'
import withRedux from './withRedux'

const PasswordInput = FormElement(
  ({
    name,
    placeholder,
    isSelected,
    errorMsg,
    warningMsg,
    onChange,
    onFocus,
    required,
    value,
    size = 1,
    disabled,
    className,
    style,
    autocomplete,
  }: IFormElementProps) => {
    const [type, setType] = React.useState('password')

    function toggleType() {
      setType(type === 'password' ? 'text' : 'password')
    }

    return (
      <Flex
        justifyEnd={true}
        alignCenter={true}
        style={{ position: 'relative' }}
      >
        <Input
          size={size}
          name={name}
          autoComplete={autocomplete}
          placeholder={placeholder}
          selected={isSelected}
          error={errorMsg && errorMsg !== ''}
          warning={warningMsg && warningMsg !== ''}
          type={type}
          onChange={onChange}
          onFocus={onFocus}
          required={required}
          value={value}
          disabled={disabled}
          className={className}
          style={style ? style : { maxHeight: `${38 * size}px` }}
        />
        <IconWrapper
          size={size}
          justifyCenter={true}
          alignCenter={true}
          onClick={toggleType}
          style={style ? { top: `${6 * size}px` } : {}}
        >
          {type === 'password' ? (
            <FiEyeOff size={18 * size} />
          ) : (
            <FiEye
              size={18 * size}
              style={{ color: theme.colors.palette.emerald }}
            />
          )}
        </IconWrapper>
      </Flex>
    )
  },
)

const ReduxField: React.ComponentType<IFormElementProps> = compose(
  withReduxForm,
  withRedux,
)(PasswordInput)

export default ReduxField
export { PasswordInput }
